import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import Toggle from 'components/toggle';
import useRoutes from 'hooks/use-routes';

import {
  Container,
  Description,
  StyledLink,
  Text,
  Title,
  ToggleContainer,
} from './round-up-toggle.styled';
import { IRoundUpToggleProps } from './types';

/**
 *
 * Round Up Toggle Component
 *
 */

const RoundUpToggle: FC<IRoundUpToggleProps> = ({ donationStatus, roundUpUpdate, disabled }) => {
  const { formatMessage } = useIntl();
  const { getLocalizedRouteForPath } = useRoutes();

  return (
    <Container data-testid="round-up-toggle-container">
      <Title>
        <Text>{formatMessage({ id: 'roundUpTitle' })}</Text>
        <ToggleContainer>
          <Toggle
            disabled={disabled}
            checked={donationStatus}
            data-testid="round-up-toggle"
            onChange={roundUpUpdate}
          />
        </ToggleContainer>
      </Title>
      <Description>
        {formatMessage(
          { id: 'roundUpDescription' },
          {
            link: (
              <StyledLink
                data-testid="tims-rewards-faq-link"
                to={getLocalizedRouteForPath('tims-rewards-faq')}
              >
                {formatMessage({ id: 'timsRewardsFaqLinkText' })}
              </StyledLink>
            ),
          }
        )}
      </Description>
    </Container>
  );
};

export default RoundUpToggle;
